
import React from 'react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { useDispatch } from 'react-redux';

import ToolButton from '../../common/client/components/toolbar/ToolButton';
import buttonCommandClick from '../../common/client/components/map/buttonCommandClick';

const ButtonCommandZoomExtent = (props) => {

    const dispatch = useDispatch();

    const getExtent = () => {
        return props.extent;
    }

    const onClick = () => {
        const extent = getExtent();

        if (extent) {
            buttonCommandClick(
                dispatch,
                'ZOOM_FEATURE',
                {
                    wkt: `LINESTRING (${extent[0]} ${extent[1]},${extent[2]} ${extent[3]})`,
                }
            );
        }
    }

    return (
        <IconButton
            className={ToolButton.TOOL_STYLE}
            iconProps={ToolButton.getIcon(props.icon || 'FitPage')}
            title={props.title || "Výchozí výřez"}
            onClick={onClick}
        />
    );
}

export default ButtonCommandZoomExtent;
